import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import InputForm from '../fields/InputForm'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"
import Dialog from '../../templates/Dialog'
import Button from '../others/Button'
import SelectorForm from '../fields/SelectorForm'
import { penjemputOpt } from '../others/Penjemput'
import { FormAttributes } from './interfaces'

function AddListIzin({closeForm,showForm,submit}:FormAttributes) {
    const methodAddListIzin = useForm({
        mode:"all",
        resolver:yupResolver(
            yup.object().shape({
                nama:yup.string().required("tidak boleh kosong"),
            })
        )
    })
    useEffect(()=>{
        if(showForm){
            methodAddListIzin.reset()
        }
    },[showForm])

    return (
        <Dialog show={showForm} toggle={closeForm}>
            <div className='bg-white md:w-[40vw] w-[95vw]'>
                <div className='py-4 px-6 border-b border-slate-200'>
                    <h1 className='text-xl'>Tambah List Izin</h1>
                </div>
                <form onSubmit={methodAddListIzin.handleSubmit(submit)} className='px-6 py-7'>
                    <InputForm label="Nama Izin" method={methodAddListIzin} methodName="nama" />
                    <div className='flex justify-end mt-5'>
                        <Button type="submit" title="Simpan" />
                    </div>
                </form>
            </div>
        </Dialog>
        )
}

export default AddListIzin